export function getPatientName(patientName?: string, responsiblePerson?: string): string {
  if (!patientName) return 'Unknown';
  if (responsiblePerson) {
    return patientName.replace(responsiblePerson, '').replaceAll('^', '');
  }
  return patientName.trim() || 'Unknown';
}
